import React from 'react'
import { Button } from './'

const OpenChatButton = ({ label }) =>
	<Button
		type={'ghost'}
		onClick={e => {
			const LC_API = window.LC_API || {}
			LC_API.open_chat_window()
		}}
	>
		{label ? label : 'Chat with us'}
	</Button>

export default OpenChatButton



// WEBPACK FOOTER //
// /opt/build/repo/packages/components/Button/OpenChatButton.js